<template>
    <div class="button-copy-url">
        <sag-button
            class="mr-1"
            :label="label"
            :addClass="addClass"
            data-toggle="tooltip"
            data-placement="top"
            :title="tip"
            variant="light"
            v-on="$listeners"
            v-bind="$attrs"
        >
            <feather-icon style="width: 20px; height: 20px;"
                icon="CopyIcon"
            />
        </sag-button>
    </div>
</template>

<script>
import { BButton, BIconPlusSquare } from 'bootstrap-vue'
import { defineEmits } from '@vue/composition-api'
import SagButton from '@/components/basic/SagButton.vue'
export default {
    components: {
        BButton,
        BIconPlusSquare,
        SagButton,
    },
    props: {
        label: {
            type: String,
            default: ''
        },
        addClass: {
            type: String,
            default: ''
        },
        tip: {
            type: String,
            default: ''
        }
    },
    setup() {

        return {
            
        }
    }
}
</script>

<style lang="scss">
.button-copy-url {
    button {
        padding: 5px;
        margin: 0px;
    }

    .sag-button {
        padding: 0px;
    }
}
</style>